import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from '../assets/Chasylmlogo.png';
import { VscAccount } from "react-icons/vsc";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { MdKeyboardArrowDown } from "react-icons/md";
import { TiShoppingCart } from "react-icons/ti";
import { Pane, Pill } from 'evergreen-ui'; // Import Evergreen UI components
import { useCart } from './Cart'; // Import useCart from Cart.js

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Mobile menu toggle
  const [dropdownOpen, setDropdownOpen] = useState(null); // Track open dropdown
  const { cartItems } = useCart(); // Access cartItems from context

  // Calculate total quantity of items in the cart
  const totalItems = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setDropdownOpen(null); // Close dropdown when menu toggled
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen(dropdownOpen === menu ? null : menu); // Toggle the specific dropdown
  };

  const closeDropdowns = () => {
    setDropdownOpen(null); // Close all dropdowns
  };

  return (
    <div className="nav-container">
      <div className="logo">
        <Link className="li-links" to="/home" onClick={closeDropdowns}>
          <img className="img_logo" style={{ height: '12vh' }} src={logo} alt="Logo" />
        </Link>
      </div>

      <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <ul className="ul-links">
          <Link className="li-links" to="/home" onClick={closeDropdowns}><li>Home</li></Link>
          
          {/* Dropdown 1 */}
          <li className="drop-menu">
            <span
              onClick={() => toggleDropdown('pages')}
              className={dropdownOpen === 'pages' ? 'active' : ''}
              style={{fontSize:'17px', fontWeight:'600'}}
            >
              Pages <MdKeyboardArrowDown/>
            </span>
            <ul className={`dropdown ${dropdownOpen === 'pages' ? 'show' : ''}`}>
              <Link className="li-links" to="/about-us" onClick={closeDropdowns}><li>About Us</li></Link>
              <Link className="li-links" to="/blogs" onClick={closeDropdowns}><li>Blog</li></Link>
              <Link className="li-links" to="/what-we-offer" onClick={closeDropdowns}><li>What We Offer</li></Link>
              <Link className="li-links" to="/contact-us" onClick={closeDropdowns}><li>Contact Us</li></Link>
              <Link className="li-links" to="/faq" onClick={closeDropdowns}><li>FAQ Page</li></Link>
            </ul>
          </li>

          <Link className="li-links" to="/destinations" onClick={closeDropdowns}><li>Destinations</li></Link>
          {/* <Link className="li-links" to="/tours" onClick={closeDropdowns}><li>Tour Packages</li></Link> */}

          <Link className="li-links" to="/request-quote" onClick={closeDropdowns}><li>Request Quote</li></Link>
          
          <Link className="li-links" to="/shop" onClick={closeDropdowns}><li>Shop</li></Link>
          <Link className="li-links" to="/car-hire" onClick={closeDropdowns}><li>Car Rental</li></Link>
          
          {/* Cart Icon with Pill */}
          <li>
            <Link className="li-links" to="/cart" onClick={closeDropdowns}>
              <Pane display="flex" alignItems="center">
                <TiShoppingCart className="nav-icon" />
                {totalItems > 0 && (
                  <Pill display="inline-flex" marginLeft={4} color="green">
                    {totalItems}
                  </Pill>
                )}
              </Pane>
            </Link>
          </li>

          {/* Dropdown 2 */}
          <li className="drop-menu">
            <span
              onClick={() => toggleDropdown('account')}
              className={dropdownOpen === 'account' ? 'active' : ''}
            >
              <VscAccount className="nav-icon" /> 
            </span>
            <ul className={`dropdown ${dropdownOpen === 'account' ? 'show' : ''}`}>
              <Link className="li-links" to="/login" onClick={closeDropdowns}><li>Login</li></Link>
              <Link className="li-links" to="/register" onClick={closeDropdowns}><li>Sign up</li></Link>
            </ul>
          </li>
        </ul>
      </div>

      <div>
        <ul>
          <li className="hamburger-menu" onClick={toggleMenu}>
            {isMenuOpen ? <AiOutlineClose className="nav-icon" /> : <GiHamburgerMenu className="nav-icon" />}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Navbar;